export default __webpack_public_path__ + "static/media/house.c0c8ae42.svg";